import React from 'react';
import { CSSTransition } from 'react-transition-group';

import LoadingImageGif from '../../assets/loading_image.gif';

interface Props {
  loading: boolean;
  displayAsBlock?: boolean;
  small?: boolean;
  tiny?: boolean;
}

const LoadingImage: React.FC<Props> = ({
  loading,
  displayAsBlock = false,
  small = false,
  tiny = false,
}) => {
  const renderImg = (
    size = '1.2em' // or 3em
  ) => (
    <CSSTransition
      in={loading}
      appear={true}
      timeout={1000}
      classNames={`animated-loading-image-${size.replace('.', '_')}`}
      style={{
        display: displayAsBlock ? 'block' : 'inline',
        margin: displayAsBlock ? 'auto' : 'default',
      }}
      unmountOnExit
    >
      <img
        className={`LoadingImage animated-loading-image-${size.replace(
          '.',
          '_'
        )}`}
        alt="loading"
        src={LoadingImageGif}
      />
    </CSSTransition>
  );
  return renderImg(tiny ? '1rem' : displayAsBlock && !small ? '3em' : '1.2em');
};

export default React.memo(LoadingImage);
